import React from "react";
import { formScreens } from "./constant";
import styles from "./styles.css";
import PropTypes from "prop-types";
import IconSpinner from "../../shared/icon-spinner";

const PreDeliveryInspectionLeadFormParent = ({
    activeFormScreen = "",
    persist = {},
    details = {}
}) => {
    const { rehydrated = false } = persist || {};
    const ActiveScreenComponent = formScreens[activeFormScreen];

    return (
        <div styleName={"styles.formWrapper"}>
            {!rehydrated ?
                <div styleName={"styles.loadingIcon"}><IconSpinner/></div> :
                <ActiveScreenComponent details={details}/>
            }
        </div>
    );
};

export default PreDeliveryInspectionLeadFormParent;

PreDeliveryInspectionLeadFormParent.propTypes = {
    activeFormScreen: PropTypes.string,
    persist: PropTypes.object,
    details: PropTypes.object
};
